// Default categories with icons, colors, and subcategories (exactly 10 categories as per categories.md)
export const DEFAULT_CATEGORIES = [
  { 
    name: "Housing & Utilities", 
    icon: "🏠", 
    color: "#795548", 
    order: 1,
    subcategories: [
      { name: "House Rent", icon: "🏠" },
      { name: "Electricity", icon: "⚡" },
      { name: "Gas", icon: "🔥" },
      { name: "Water", icon: "💧" },
      { name: "Internet", icon: "🌐" }
    ]
  },
  { 
    name: "Groceries", 
    icon: "🛒", 
    color: "#4CAF50", 
    order: 2,
    subcategories: [
      { name: "Weekly Groceries", icon: "🛒" },
      { name: "Daily Essentials", icon: "🥛" },
      { name: "Market Shopping", icon: "🥬" }
    ]
  },
  { 
    name: "Transportation", 
    icon: "🚗", 
    color: "#2196F3", 
    order: 3,
    subcategories: [
      { name: "Daily Commute", icon: "🚌" },
      { name: "Uber/Ride Share", icon: "🚗" },
      { name: "CNG/Rickshaw", icon: "🛺" },
      { name: "Bus/Train", icon: "🚌" },
      { name: "Fuel (if own vehicle)", icon: "⛽" }
    ]
  },
  { 
    name: "Dining Out", 
    icon: "🍽️", 
    color: "#9C27B0", 
    order: 4,
    subcategories: [
      { name: "Dinner Dates", icon: "🍽️" },
      { name: "Casual Dining", icon: "🍕" },
      { name: "Fast Food", icon: "🍔" },
      { name: "Cafe/Coffee", icon: "☕" }
    ]
  },
  { 
    name: "Entertainment", 
    icon: "🎬", 
    color: "#E91E63", 
    order: 5,
    subcategories: [
      { name: "OTT Subscriptions", icon: "📺" },
      { name: "Movie Theater", icon: "🎬" },
      { name: "Events/Concerts", icon: "🎵" },
      { name: "Hobbies", icon: "🎨" },
      { name: "Gaming", icon: "🎮" }
    ]
  },
  { 
    name: "Healthcare", 
    icon: "🏥", 
    color: "#F44336", 
    order: 6,
    subcategories: [
      { name: "Medicine", icon: "💊" },
      { name: "Doctor Visits", icon: "👨‍⚕️" },
      { name: "Lab Tests", icon: "🧪" },
      { name: "Supplements", icon: "💊" },
      { name: "Health Insurance", icon: "🏥" }
    ]
  },
  { 
    name: "Personal Care", 
    icon: "💆", 
    color: "#607D8B", 
    order: 7,
    subcategories: [
      { name: "Toiletries", icon: "🧴" },
      { name: "Grooming", icon: "✂️" },
      { name: "Salon/Barber", icon: "💇" },
      { name: "Skincare", icon: "🧴" },
      { name: "Hygiene Products", icon: "🧼" }
    ]
  },
  { 
    name: "Shopping", 
    icon: "🛍️", 
    color: "#3F51B5", 
    order: 8,
    subcategories: [
      { name: "Clothing", icon: "👕" },
      { name: "Shoes", icon: "👟" },
      { name: "Electronics", icon: "📱" },
      { name: "Accessories", icon: "⌚" },
      { name: "Home Items", icon: "🛋️" }
    ]
  },
  { 
    name: "Family & Gifts", 
    icon: "🎁", 
    color: "#E91E63", 
    order: 9,
    subcategories: [
      { name: "Family Support", icon: "👨‍👩‍👧‍👦" },
      { name: "Gifts for Family", icon: "🎁" },
      { name: "Gifts for Friends", icon: "🎈" },
      { name: "Special Occasions", icon: "🎉" },
      { name: "Charity/Donations", icon: "🤲" }
    ]
  },
  { 
    name: "Trip & Vacation", 
    icon: "🛫", 
    color: "#00BCD4", 
    order: 10,
    subcategories: [
      { name: "Trip", icon: "�" },
      { name: "Vacation", icon: "�️" },
      { name: "Hotel", icon: "�" },
      { name: "Flight", icon: "✈️" },
      { name: "Car Rental", icon: "🚗" },
      // honeymoons
      { name: "Honeymoon", icon: "💒" },
      { name: "Wedding", icon: "💒" },
      { name: "Birthday", icon: "🎉" },
      { name: "Anniversary", icon: "🎉" },
      { name: "Christmas", icon: "🎄" },
      { name: "New Year", icon: "🎉" },
      { name: "Eid", icon: "🎉" },
    ]
  },
  { 
    name: "Savings", 
    icon: "💰", 
    color: "#4CAF50", 
    order: 11,
    subcategories: [
      { name: "Emergency Fund", icon: "🚨" },
      { name: "Investment", icon: "📈" },
      { name: "Vacation Fund", icon: "✈️" },
      { name: "Future Goals", icon: "🎯" },
      { name: "Retirement", icon: "👴" }
    ]
  }
];

// Priority types
export const PRIORITY_TYPES = {
  NEED: 'need',
  WANT: 'want',
  SAVINGS: 'savings'
};

export const PRIORITY_LABELS = {
  [PRIORITY_TYPES.NEED]: 'Need',
  [PRIORITY_TYPES.WANT]: 'Want',
  [PRIORITY_TYPES.SAVINGS]: 'Savings'
};

export const PRIORITY_COLORS = {
  [PRIORITY_TYPES.NEED]: '#EF4444',     // Red
  [PRIORITY_TYPES.WANT]: '#F59E0B',     // Yellow
  [PRIORITY_TYPES.SAVINGS]: '#10B981'   // Green
};

// User roles
export const USER_ROLES = {
  ADMIN: 'admin',
  PARTNER1: 'partner1',
  PARTNER2: 'partner2'
};

// Income sources
export const INCOME_SOURCES = [
  'Salary',
  'Freelance',
  'Investment',
  'Gift',
  'Other'
];

// Recurring frequencies
export const RECURRING_FREQUENCIES = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  YEARLY: 'yearly'
};

// Budget alert thresholds
export const BUDGET_THRESHOLDS = {
  WARNING: 75,
  CRITICAL: 90,
  EXCEEDED: 100
};

// Date formats
export const DATE_FORMATS = {
  US: 'MM/DD/YYYY',
  INTERNATIONAL: 'DD/MM/YYYY',
  ISO: 'YYYY-MM-DD'
};

// Supported currencies
export const CURRENCIES = [
  { code: 'BDT', symbol: '৳', name: 'Bangladeshi Taka' },
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee' }
];

// Default currency
export const DEFAULT_CURRENCY = 'BDT';

// App routes
export const ROUTES = {
  // Public routes
  LOGIN: '/login',
  SIGNUP: '/signup',
  RESET_PASSWORD: '/reset-password',
  
  // Onboarding routes
  ONBOARDING: '/onboarding',
  ONBOARDING_INVITE: '/onboarding/invite',
  
  // Main app routes
  DASHBOARD: '/',
  EXPENSES: '/expenses',
  ADD_EXPENSE: '/expenses/add',
  EXPENSE_DETAIL: '/expenses/:id',
  BUDGET: '/budget',
  CREATE_BUDGET: '/budget/create',
  ANALYTICS: '/analytics',
  ANALYTICS_TAGS: '/analytics/tags',
  SETTINGS: '/settings',
  SETTINGS_PROFILE: '/settings/profile',
  SETTINGS_CATEGORIES: '/settings/categories',
  SETTINGS_PREFERENCES: '/settings/preferences',
  SETTINGS_FAMILY: '/settings/family',
  SETTINGS_TAGS: '/settings/tags'
};